<template>
	<div id="">
		<h3>协议</h3>
		<div class="know" v-html="urllist"></div>
	</div>
	
</template>

<script>
	import utilFile from "@/ace/ace.js";
	export default {
		name:'agreement',
		components: {
		},
		data(){
			return{
				urllist:'',
			}
		},
		methods:{
			agreementfuc(key){
		    	var	data = utilFile.encrypt(JSON.stringify({
					key,
				}));
		    	this.$axios({
	                method: 'post',
	                url: `/api/single.getKey?parameter=${data}`,
	                data:{},
	                withCredentials: true,
				    headers: {
				        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				    }
	                
	            }).then((res)=>{
	            	
	            	this.urllist = JSON.parse(utilFile.decrypt(res.data.data)).content;
	            	console.log(this.urllist)
	            })
		    }
		},
		mounted(){
			
			this.agreementfuc(this.$route.query.key);
			
		}
	}
</script>

<style scoped>
	.know{
		box-sizing: border-box;
		padding: 7%;
		padding-top: 0;
		background-color: #FFFFFF;
		margin: auto;
		font-size: 13px;
		color: #8e8d97;
		line-height: 1.6em;
		text-align: left;
		margin-top: 16px;
	}
</style>